import {
  MAIN_INDICATORS,
  MAIN_INDICATORS_ERROR,
  MAIN_INDICATORS_SUCCESS,
  MAIN_INDICATORS_DETAILS,
  MAIN_INDICATORS_DETAILS_SUCCESS
} from './MainIndicators.actions'

const initialState = {
  data: { licMas: {}, licMin: {}, licDes: {} },
  details: { csvStructure: [], tableStructure: [] },
  error: null,
  fetched: false,
  fetching: false
}

/**
 * Main Indicators's reducer.
 */
const mainIndicatorsReducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case MAIN_INDICATORS: {
      return { ...state, fetching: true }
    }
    case MAIN_INDICATORS_ERROR: {
      return { ...state, error: payload.error }
    }
    case MAIN_INDICATORS_SUCCESS: {
      return { ...state, data: payload, fetching: false, fetched: true }
    }
    case MAIN_INDICATORS_DETAILS: {
      return { ...state, fetching: true }
    }
    case MAIN_INDICATORS_DETAILS_SUCCESS: {
      return { ...state, details: payload, fetching: false, fetched: true }
    }
    default: {
      return state
    }
  }
}

export default mainIndicatorsReducer
